import React, { FC } from 'react';
import { SubMenu as ReactSubMenu } from 'react-contextmenu';
import { ContextMenuItem, WixIcons } from '../..';
import styles from './SubMenu.scss';
import { IOuter } from './SubMenu.types';

export const SubMenu: FC<IOuter> = ({ title, dataHook, className, ...otherProps }) => (
  <ReactSubMenu
    className={className}
    title={
      <ContextMenuItem
        title={title}
        dataHook={dataHook}
        hotKey={<WixIcons.ChevronRightSmall className={styles.icon} />}
      />
    }
    preventCloseOnClick
    {...otherProps}
  />
);
